import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Board from 'react-trello';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import {
  encryptId,
  formatPrice,
  KTSVG,
} from '../../../../../_metronic/helpers';
import { colorStatusCuentasCobrar } from '../../../../../_metronic/helpers/CustomElements';
import {
  actualizarEtapaOrdenCobro,
  actualizarNombreEtapaOC,
} from '../../../../service/cuentas_cobrar/CuentasCobrar';

type Props = {
  etapasConCuentas: any;
  onRefreshData: () => void;
};

const ListadoTarjeta: React.FC<Props> = ({
  etapasConCuentas,
  onRefreshData,
}) => {
  const history = useHistory();
  const [actualizaTablero, setActualizaTablero] = useState<number>(
    Math.random() * 40
  );
  const databoard = {
    lanes: etapasConCuentas,
  };
  const tarjeta = (props: any) => {
    const {
      id,
      nombre,
      vendedorAsignado,
      draggable,
      tipoPago,
      cobro,
      unidadMoneda,
      estatus,
      cobrador,
    } = props;

    let nombre_estatus = '';
    let codigo_estatus = '';
    if (estatus) {
      nombre_estatus = estatus.name;
      codigo_estatus = estatus.code;
    }

    return (
      <div
        className="card mb-2 borders-card-board cursor-pointer"
        onClick={() => {
          history.push(`/cobranza/cuentas_cobrar/${encryptId(id.toString())}`);
        }}
        title={nombre}
        style={{ cursor: !draggable ? 'not-allowed' : '' }}
      >
        <div className="card-header d-flex border-0 mt-3 padding-card-board ">
          <div className="wh-0100">
            <div className="sp-bt-c wh-0100">
              <span className="fw-bolder text-gray-700 large-text">
                {nombre}
              </span>
              {cobrador ? (
                <>
                  <div className="symbol symbol-40px">
                    {cobrador && cobrador.profile_photo ? (
                      <img
                        src={`${process.env.REACT_APP_PUBLIC}users/${cobrador.profile_photo}`}
                        title={`${cobrador.first_name} ${cobrador.father_last_name} ${cobrador.mother_last_name}`}
                        crossOrigin="anonymous"
                        className="symbol-label fs-5 "
                        alt="user"
                      />
                    ) : (
                      <span
                        className="symbol-label fs-5 fw-bold bg-light-primary text-primary fw-bold"
                        title={`${cobrador.first_name} ${cobrador.father_last_name} ${cobrador.mother_last_name}`}
                      >{`${cobrador.first_name[0]}${cobrador.father_last_name[0]}`}</span>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <span className="symbol symbol-40px cursor-pointer tooltip-soft">
                    <div className="symbol-label" title="No asignado">
                      <KTSVG
                        path="/media/icons/duotune/communication/com006.svg"
                        className="svg-icon-1"
                      />
                    </div>
                  </span>
                </>
              )}
            </div>
          </div>
          <div>
            <div>
              <span className="text-gray-700 mt-1 fw-bold fs-7">
                {tipoPago ? tipoPago.name : 'N/A'}
              </span>
            </div>
          </div>
        </div>
        <div className="card-body padding-card-board">
          <div className="sp-bt-c mb-5">
            <div className="text-gray-600 mt-1 fw-semibold fs-7 mb-2">
              <span className="text-gray-700 fw-bolder">
                {`${formatPrice(cobro, 'es-MX', 'MXN', 2, 2)}`}
              </span>
              <span className="text-gray-600 ms-3 fs-8">
                {unidadMoneda
                  ? `/ ${unidadMoneda.code}`
                  : 'Sin unidad de moneda'}
              </span>
            </div>
            <div className="margin-left-020">
              <span className={`${colorStatusCuentasCobrar(codigo_estatus)}`}>
                {nombre_estatus}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const encabezado = (props: any) => {
    const {
      color_etapa,
      title,
      monto_total_usd,
      monto_total_mxn,
      code,
      etapa_id,
    } = props;
    return (
      <>
        <div
          className="card borders"
          style={{ borderTop: `solid 5px ${color_etapa}` }}
        >
          <div
            className="sp-bt-c padding-card-board"
            style={{ minHeight: '60px' }}
          >
            <div className="d-flex w-50">
              {code !== 'ORD_COB' && code !== 'PAG' ? (
                <>
                  <input
                    className="large-text fw-bolder text-gray-700"
                    style={{
                      border: 'none',
                      backgroundColor: '#fff',
                      outline: 'none',
                    }}
                    defaultValue={title}
                    onKeyDown={(event: any) => {
                      if (
                        event.target.value.length >= 20 &&
                        event.key !== 'Backspace' &&
                        event.key !== 'Delete'
                      ) {
                        event.preventDefault();
                      }

                      if (event.key === 'Enter') {
                        actualizarNombreEtapa(
                          event.target.value,
                          code,
                          etapa_id
                        );
                      }
                    }}
                    title={''}
                    onBlur={(event: any) => {
                      actualizarNombreEtapa(event.target.value, code, etapa_id);
                    }}
                  />
                </>
              ) : (
                <div className="large-text fw-bolder text-gray-700">
                  {title}
                </div>
              )}
            </div>
            <div
              className="text-muted cursor-pointer "
              title="Total de cuentas"
            >
              {props.cards.length}
            </div>
          </div>
          <div className="d-flex gap-2 flex-wrap w-100 mb-4">
            <span
              className="badge badge-light-success fs-7 fw-bold ms-8"
              title="Total en MXN"
            >
              {`${formatPrice(monto_total_mxn, 'es-MX', 'MXN', 2, 2)}`} MXN
            </span>
            <span
              className="badge badge-light-info fs-7 fw-bold"
              title="Total en USD"
            >
              {`${formatPrice(monto_total_usd, 'es-MX', 'MXN', 2, 2)}`} USD
            </span>
          </div>
        </div>
      </>
    );
  };
  const actualizarNombreEtapa = async (
    nombre: string,
    codigo: string,
    etapa_id: number
  ) => {
    let data = {
      id: etapa_id,
      code: codigo,
      name: nombre,
    };
    actualizarNombreEtapaOC('', data)
      .then((res) => {})
      .catch((err) => {
        let resMessageToast: string = '';
        const {
          data: { message, details = null },
        } = err.response;
        resMessageToast = `${message}`;

        toast.error(
          'Hubo un problema al intentar cambiar el nombre de la etapa, intentelo más tarde',
          {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          }
        );
      });
  };

  const actualizaOrden = async (id: number, codeStage: string) => {
    const values = {
      id: id,
      etapaCode: codeStage,
    };
    actualizarEtapaOrdenCobro(values)
      .then((res) => {
        const {
          data: { message },
        } = res;
        onRefreshData();
        toast.success(message, {
          position: 'top-right',
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      })
      .catch((err) => {
        onRefreshData();
        toast.error(
          'Hubo un problema al intentar cambiar de etapa de la orden, intentelo más tarde',
          {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          }
        );
      });
  };
  const components = {
    Card: tarjeta,
    LaneHeader: encabezado,
  };

  return (
    <>
      {
        <Board
          key={actualizaTablero}
          data={databoard}
          onCardClick={(event: any) => {}}
          handleDragEnd={async (
            cardId: any,
            sourceLaneId: any,
            targetLaneId: any,
            position: any,
            cardDetails: any
          ) => {
            if (targetLaneId !== sourceLaneId) {
              switch (targetLaneId) {
                case 'PAG':
                  Swal.fire({
                    title: '¿Confirmas que deseas cambiar la orden a pagada?',
                    html: `
                    <div className="text-gray-600">
                      La orden de cobro se marcará como pagada. Una vez pagada, no podrás modificar ningún dato asociado a ella.
                    </div>
                    `,
                    showCancelButton: true,
                    padding: '2em',
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Aceptar',
                    reverseButtons: true,
                    customClass: {
                      confirmButton: 'btn btn-primary',
                      cancelButton: 'btn btn-light me-3',
                    },
                  }).then((result) => {
                    if (result.isConfirmed) {
                      actualizaOrden(cardId, targetLaneId);
                    } else {
                      setActualizaTablero(Math.random() * 40);
                    }
                  });
                  break;
                default:
                  actualizaOrden(cardId, targetLaneId);
                  break;
              }
            }
          }}
          editable
          components={components}
        />
      }
    </>
  );
};

export { ListadoTarjeta };
